import { getP } from '../../core/selectors.js';
import { render } from '../../core/shell.js';
import { S, UI, save } from '../../core/store.js';
import { $, uid } from '../../core/util.js';
import { actions, changes } from './actions.js';
import { initProjectDnd } from './dnd.js';
import { npPreview } from './create.js';
import { vProject } from './detail.js';
import { plistHtml, vProjects } from './list.js';

export default {
  id: 'projects', label: 'Projects', icon: 'projects', nav: true, show: () => true,
  view: vProjects,
  views: { project: vProject },
  actions, changes,
  inputs: {
    psearch(t) { UI.pq = t.value; const l = $('#plist'); if (l) l.innerHTML = plistHtml(); },
    npchg() { npPreview(); }
  },
  enters: {
    tadd(en, v) {
      if (!v) return;
      const p = getP(en.dataset.p);
      p.tasks.push({ id: uid(), ph: en.dataset.ph, title: v, status: 'todo', due: null, who: S.me });
      save();
      UI._keep = `input[data-enter="tadd"][data-ph="${en.dataset.ph}"]`;
      render();
    }
  },
  init() {
    $('#fu').addEventListener('change', (e) => changes.upload(e.target));
    initProjectDnd();
  }
};
